export class FillterReciveMoneyQrCode{
    fromDate:any;
    toDate:any;
    empId:number;
    hubId:number;
    textSearch:string;
    pageNumber:number=1;
    pageSize:number =20;
}